import styled from "styled-components"

export default styled.div`
  width: 95%;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  .MuiInputBase-root {
    & input[type=search] {
      width: 17vw;
      min-width 280px;
    }
  }
`

export const LeftWrapper = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
`

export const RightWrapper = styled.div`
  display: flex;
  gap: 1.75rem;
  width: fit-content;
  align-items: center;
  margin: 0 1.5rem;
  & .status-filter{
    display: flex;
    width: fit-content;
    align-items: center;
    gap: 1rem;
    & .MuiInputLabel-root{
      font-size: 1.25rem;
    }
    & .MuiSelect-select {
      font-size: 1.25rem;
    }
    & .MuiMenuItem-root{
      font-size: 1.25rem;
    }
  }
`
